import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import Modal from '@ui/modal/modal';
import Text from '@ui/text/text/text';

type Props = {
  open: boolean;
  email?: string;
  onClose: () => void;
  handleSendGreenroomInvite: () => void;
  sendingInvite?: boolean;
};
const SendInviteModal = ({ open, email, onClose, handleSendGreenroomInvite, sendingInvite }: Props) => {
  return (
    <Modal
      open={open && !!email?.trim().length}
      onRequestClose={onClose}
      customSize={{
        width: '420px',
        maxWidth: 'calc(100vw - 20px)',
        height: 'fit-content',
        minHeight: '226px',
      }}
      modalClassName="overflow-hidden"
      backgroundColor="inherit"
      RenderFooterContent={() => (
        <Container
          design="GlobalCont1"
          padding="16px 32px 24px 32px"
          className="flex ai-center jc-flex-end gap-8"
          borderRadius="0 0 24px 24px"
        >
          <Button design="LocalBttnSec" onClick={onClose} designSize="medium">
            Cancel
          </Button>
          <Button
            design="LocalBttnPrim"
            onClick={handleSendGreenroomInvite}
            designSize="medium"
            disabled={sendingInvite}
          >
            Send
          </Button>
        </Container>
      )}
    >
      <Container
        design="GlobalCont1"
        minHeight="100%"
        height="fit-content"
        width="100%"
        borderRadius="24px 24px 0 0"
        padding="32px 32px 24px 32px"
      >
        <Text design="GlobalIcoText1" className="H4 margin-b-8">
          Send invitation?
        </Text>
        <Text design="GlobalIcoText1" className="P1">
          Are you sure you want to send invitation to
        </Text>
        <Text design="GlobalIcoText1" className="S1">
          {email}
        </Text>
      </Container>
    </Modal>
  );
};

export default SendInviteModal;
